/* eslint-disable max-len */
// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import api from '../../../services/api';

const packGuidelinesService = async () => {
  return api('/api/v2/pages/?type=packaging_guide.PackagingGuidePage&fields=description,main_image,gallery_image_picker(title,description)', {}, 'GET');
};


export {
  packGuidelinesService,
};
